export const regexPatterns = {
  emailRegex:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  alphaNumericRegex: /^[a-zA-Z0-9\s]+$/,
  numericOnlyRegex: /^[0-9]+$/,
  emailTestRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  baseTruckAssumptionValues: /^(.+?)_(bidding_config_tons|config_rate)$/,
  // Regular expression to match:
  // - Optional negative sign
  // - One or more digits
  // - Optional decimal point followed by one or more digits
  numericRegex: /^-?\d+(\.\d+)?$/,
  searchRegex: /^[a-zA-Z0-9\s_-]+$/,
  ticketNumberRegex: /^[a-zA-Z0-9\s_\-?]+$/,
  alphabetsOnlyRegex: /^[a-zA-Z]+$/,
  alphabetsOnlyRegexWithSpace: /^[a-zA-Z\s]+$/,
  urlRegex: /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i,
  phoneNumberRegex: /^(?:\D*\d){10}\D*$/,
};
